<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col>
        <v-card flat width="20%">
          <v-card-text>
            <v-menu ref="fechaDialogReporte" v-model="modalFechas" :close-on-content-click="false" :nudge-right="-17"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense v-model="selectedRangueFecha" label="Días" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240" no-title
                scrollable v-model="dialogVarSelectedRangueFecha" range :max="disabledFecha" color="primary"
                header-color="primary">
                <v-spacer></v-spacer>
                <!-- <v-btn text color="primary" @click="setModalFechas(false)">
                  Cancelar
                </v-btn> -->
                <v-btn text color="primary" @click="saveDateRange(dialogVarSelectedRangueFecha), setModalFechas(false)">
                  cerrar
                </v-btn>
              </v-date-picker>
            </v-menu>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- {{ getParams() }} -->
    <v-data-table disable-pagination :options.sync="options" :hide-default-footer="true" :headers="headers"
      :items="items">
      <template v-slot:top>
        <v-row no-gutters>
          <v-spacer>

          </v-spacer>
          <v-btn x-small @click="main()" class="mt-3 ml-1 mr-1 flo" color="primary">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
          <v-btn x-small @click="applyFilters" class="mt-3 ml-1 mr-1 flo" color="primary">
            Búscar
          </v-btn>

          <v-btn :loading="loading" x-small @click="exportToExcel" class="mt-3 ml-1 mr-1 flo" color="success">
            Exportar a Excel
          </v-btn>
          <v-btn :loading="loading" x-small @click="exportToPDF" class="mt-3 ml-1 mr-1 flo" color="success">
            Exportar a PDF
          </v-btn>
        </v-row>
      </template>
      <template v-slot:header>
        <tr>
          <td v-for="header in filteredHeaders" :key="header.value">
            <v-text-field @keydown.enter="applyFilters()" dense
              v-if="header.type === 'date' || header.type === 'datetime' || header.type === 'dateUTC'"
              v-model="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-text-field @keydown.enter="applyFilters()" dense v-if="header.type === 'string'"
              v-model="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-text-field @keydown.enter="applyFilters()" dense v-if="header.type === 'integer'" type="number" step="1"
              v-model.number="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-select @change="applyFilters()" clearable dense v-if="header.type === 'boolean'"
              v-model="filters[header.value]" :items="booleanOptions" :label="`${header.text}`" hide-details
              solo></v-select>
            <!-- Add other input types as needed -->
          </td>
        </tr>
      </template>

      <template v-slot:[`item.estado`]="{ item }">
        <span>{{ item.estado }}</span>
        <span v-if="item.estado == 'Gestión cancelada'"> - {{ item.flag_precalificacion_cancelada_motivo }}</span>
      </template>

      <template v-slot:[`item.nombre`]="{ item }">
        {{ item.primer_nombre }} {{ item.segundo_nombre }}
        {{ item.tercer_nombre }} {{ item.primer_apellido }}
        {{ item.segundo_apellido }} {{ item.tercer_apellido_o_casada }}
      </template>
      <template v-slot:[`item.campania`]="{ item }">
        {{ getYearMonth(item.fecha_campania) }}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ fnGetDateTime(item.createdAt) }}
      </template>
      <template v-slot:[`item.flag_precalificacion_completada_fecha`]="{ item }">
        {{ fnGetDateTime(item.flag_precalificacion_completada_fecha) }}
      </template>
      <template v-slot:[`item.flag_precalificacion_en_revision_fecha`]="{ item }">
        {{ fnGetDateTime(item.flag_precalificacion_en_revision_fecha) }}
      </template>
      <template v-slot:[`item.fecha_de_nacimiento`]="{ item }">
        {{ fnGetDateUTC(item.fecha_de_nacimiento) }}
      </template>
      <template v-slot:[`item.flag_tiene_pedido`]="{ item }">
        <span v-if="item.flag_tiene_pedido == 1">Si</span>
        <span v-if="item.flag_tiene_pedido != 1">No</span>
      </template>
      <template v-slot:[`item.fecha_campania`]="{ item }">
        {{ fnGetDateUTC(item.fecha_campania) }}
      </template>
      <template v-slot:[`item.autorizacion`]="{ item }">
        {{ item.estado }}
      </template>
      <template v-slot:[`item.resultado_evaluacion`]="{ item }">
        <v-chip v-if="item.resultado_evaluacion == 'rechazado'"
          :color="item.resultado_evaluacion == 'rechazado' ? 'red' : ''" dark> ROJO </v-chip>
        <v-chip v-if="item.resultado_evaluacion == 'revisión'"
          :color="item.resultado_evaluacion == 'revisión' ? 'yellow accent-2' : ''"> AMARILLO </v-chip>
        <v-chip v-if="item.resultado_evaluacion == 'aprobado'"
          :color="item.resultado_evaluacion == 'aprobado' ? 'green' : ''" dark> VERDE </v-chip>
      </template>
    </v-data-table>
    <v-row>
      <!-- PAGINACIÓN -->
      <v-col cols="12">
        <v-col offset="9" cols="3">
          <v-select v-model="pageSize" :items="pageSizes" label="Registros por página"
            @change="handlePageSizeChange"></v-select>
        </v-col>
        <v-col class="">
          Total de registros: {{ totalRegistros }}
          <v-pagination class="float-right" v-model="page" :length="totalPages" total-visible="15"
            next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
        </v-col>
      </v-col>
      <!-- FIN PAGINACIÓN -->
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment';
require('moment/locale/es.js');
import { mapActions, mapGetters } from 'vuex';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {

  data() {
    return {
      loading: false,
      //
      booleanOptions: [
        { text: 'Sí', value: 1 },
        { text: 'No', value: 0 },
      ],
      //pagination
      options: {},
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [10, 25, 50, 100],
      totalRegistros: 0,
      //pagination fin
      headers: [

        { text: 'Gestión ID', value: 'id', type: 'integer', width: 90 },
        { text: 'Nombre Campaña', value: 'campania', type: 'string' },
        { text: 'Score general', value: 'resultado_evaluacion', type: 'string' },
        {
          text: 'Nombre completo',
          value: 'deudor_nombre_completo',
          type: 'string',
          width: 185
        },
        { text: 'Score Equifax', value: 'resultado_evaluacion_equifax_score', type: 'integer' },
        {
          text: 'Nombre completo (fiador)',
          value: 'fiador_nombre_completo',
          type: 'string',
          width: 185
        },
        { text: 'Score Equifax (fiador)', value: 'fiador_resultado_evaluacion_equifax_score', type: 'integer' },
        { text: 'Fecha inicio Gestión', value: 'flag_precalificacion_en_revision_fecha', type: 'datetime', width: 155 },
        { text: 'Fecha de nacimiento', value: 'fecha_de_nacimiento', type: 'dateUTC', width: 155 },
        { text: 'NIT', value: 'nit', type: 'string', width: 90 },
        { text: 'CUI/DUI', value: 'dpi', type: 'string' },

        { text: 'Usuario Gestión móvil', value: 'CREADO_POR_USUARIO', type: 'string', width: 130 },
        { text: 'Nombre Usuario Gestión móvil', value: 'CREADO_POR_USUARIO_NOMBRE', type: 'string', width: 185 },

        { text: 'Sector', value: 'sector', type: 'integer' },
        { text: 'Region', value: 'region', type: 'string', width: 130 },
        { text: 'División', value: 'division', type: 'string', width: 130 },

        { text: 'Tipo cliente', value: 'buro_tipo_de_usuario', type: 'string' },
        { text: 'Fecha de evaluación', value: 'fecha_campania', type: 'dateUTC', width: 155 },
        {
          text: 'Fecha de sincronización',
          align: 'start',
          value: 'createdAt',
          sortable: false,
          width: 180,
          type: 'datetime'
        },
        {
          text: 'Fecha de carga expediente completo',
          align: 'start',
          value: 'flag_precalificacion_completada_fecha',
          sortable: false,
          width: 180,
          type: 'datetime'
        },
        { text: 'Estado', value: 'estado', type: 'string', width: 180 },
        { text: 'Código SAP', value: 'codigo_sap', type: 'string' },

        { text: 'Usuario Gestión Web', value: 'inicio_de_gestion_web', type: 'string', width: 155 },
        { text: 'Comentario movil motivo de eliminación', value: 'flag_precalificacion_eliminada_motivo', type: 'string', width: 175 },
        // { text: 'Comentario Gestión Web', value: 'estado', type: 'string' },
        /**TODO: llenar las columnas de comentario 'móvil' */
        //{ text: 'Usuario Gestión Móvil', value: 'CREADO_POR_USUARIO', type: 'string' },
        //{ text: 'Comentario Gestión Móvil', value: 'CREADO_POR_USUARIO_NOMBRE', type: 'string' },
        // Add other headers with types
      ],
      items: [],
      filters: {
        id: '',
        campania: '',
        resultado_evaluacion: '',
        deudor_nombre_completo: '',
        resultado_evaluacion_equifax_score: '',
        fiador_nombre_completo: '',
        fiador_resultado_evaluacion_equifax_score: '',
        flag_precalificacion_en_revision_fecha: '',
        fecha_de_nacimiento: '',
        nit: '',
        dpi: '',
        CREADO_POR_USUARIO: '',
        CREADO_POR_USUARIO_NOMBRE: '',
        sector: '',
        region: '',
        division: '',
        buro_tipo_de_usuario: '',
        fecha_campania: '',
        createdAt: '',
        flag_precalificacion_completada_fecha: '',
        estado: '',
        codigo_sap: '',
        inicio_de_gestion_web: '',
        flag_precalificacion_eliminada_motivo: '',
      },
      filterConfig: {
        id: true,
        campania: true,
        resultado_evaluacion: true,
        deudor_nombre_completo: true,
        resultado_evaluacion_equifax_score: true,
        fiador_nombre_completo: true,
        fiador_resultado_evaluacion_equifax_score: true,
        flag_precalificacion_en_revision_fecha: true,
        fecha_de_nacimiento: true,
        nit: true,
        dpi: true,
        CREADO_POR_USUARIO: true,
        CREADO_POR_USUARIO_NOMBRE: true,
        sector: true,
        region: true,
        division: true,
        buro_tipo_de_usuario: true,
        fecha_campania: true,
        createdAt: true,
        flag_precalificacion_completada_fecha: true,
        estado: true,
        codigo_sap: true,
        inicio_de_gestion_web: true,
        flag_precalificacion_eliminada_motivo: true,
      },
    };
  },
  computed: {
    modalFechas: {
      get() {
        return this.$store.state.modalFechas;
      },
      set(value) {
        this.$store.dispatch('setModalFechas', value);
      }
    },
    dialogVarSelectedRangueFecha: {
      get() {
        return this.$store.state.dialogVarSelectedRangueFecha;
      },
      set(value) {
        this.$store.dispatch('setDialogVarSelectedRangueFecha', value);
      }
    },
    selectedRangueFecha() {
      return this.$store.state.selectedRangueFecha;
    },
    disabledFecha() {
      return this.$store.state.disabledFecha;
    },
    ...mapGetters([
      'getFirstDay',
      'getLastDay',
    ]),
    filteredHeaders() {
      return this.headers.filter((header) => this.filterConfig[header.value]);
    },
    isFilterChanged() {
      return Object.values(this.filters).some((filter) => filter !== '');
    },
  },
  watch: {
    options: {
      // eslint-disable-next-line no-unused-vars
      handler(newValue) {
        this.main();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async exportToPDF() {
      this.loading = true;
      try {
        // Obtener todos los registros
        const allRecords = await this.getAllRecords();

        // Crear el documento PDF en orientación vertical
        const doc = new jsPDF('landscape', 'pt', 'a4');

        // Preparar los datos para la tabla
        const tableData = allRecords.map((record) =>
          this.headers.map((header) => {
            if (header.value === 'estado') {
              if (record.estado == 'Gestión cancelada') {
                return record.estado + '-' + record.flag_precalificacion_cancelada_motivo;
              } else return record.estado
            } else {
              return this.formatCellValue(record[header.value], header.type);
            }
          }
          )
        );

        // Definir las columnas
        const tableColumns = this.headers.map((header) => ({
          header: header.text,
          dataKey: header.value,
        }));

        // Calcular el ancho de página disponible
        const pageWidth = doc.internal.pageSize.getWidth();

        // Añadir la tabla al PDF
        doc.autoTable({
          head: [tableColumns.map((col) => col.header)],
          body: tableData,
          startY: 20,
          styles: {
            fontSize: 6,
            cellPadding: 2,
          },
          headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontSize: 6,
            fontStyle: 'bold',
          },
          columnStyles: {
            0: { cellWidth: 'auto' }, // ID column
            1: { cellWidth: 'auto' }, // Adjust as needed for other columns
          },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          margin: { top: 20, right: 10, bottom: 20, left: 10 },
          tableWidth: pageWidth - 20, // Full width minus margins
        });

        // Guardar el archivo PDF
        doc.save('LISTADO DE GESTIONES POR SECTOR, COLOR Y AUTORIZACION.pdf');
        this.loading = false;
      } catch (error) {
        console.error('Error al exportar a PDF:', error);
        this.loading = false;
        // Aquí puedes agregar un manejo de errores más robusto, como mostrar un mensaje al usuario
      }
    },

    formatCellValue(value, type) {
      if (type === 'deudor') {
        return 'deudor';
      }
      if (type === 'datetimeUTC') {
        return this.fnGetDateUTCTime(value);
      }
      if (type === 'dateUTC') {
        return this.fnGetDateUTC(value);
      }
      if (type === 'date') {
        return this.fnGetDate(value);
      }
      if (type === 'datetime') {
        return this.fnGetDateTime(value);
      }
      if (type === 'boolean') {
        if (value == 1) {
          return 'Si'
        }
        else if (value == 0) {
          return 'No'
        } else {
          return '-'
        }
      }
      // Manejar otros tipos según sea necesario
      return value;
    },
    /** fin pdf */
    async exportToExcel() {
      this.loading = true;
      try {
        let XLSX = require('xlsx');
        // Obtener todos los registros
        const allRecords = await this.getAllRecords();

        // Preparar los datos para el Excel
        const excelData = allRecords.map((record) => {
          let rowData = {};
          this.headers.forEach((header) => {
            // Usar el 'text' como nombre de columna y 'value' para obtener el dato
            if (header.value === 'estado') {
              if (record.estado == 'Gestión cancelada') {
                rowData[header.text] = record.estado + ' - ' + record.flag_precalificacion_cancelada_motivo;
              } else rowData[header.text] = record.estado

            } else {
              rowData[header.text] = this.formatCellValue(record[header.value], header.type);
            }
          });
          return rowData;
        });

        // Crear una hoja de trabajo
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Crear un libro de trabajo y agregar la hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Registros');

        // Guardar el archivo
        XLSX.writeFile(wb, 'LISTADO DE GESTIONES POR SECTOR, COLOR Y AUTORIZACION.xlsx');
        this.loading = false;
      } catch (error) {
        console.error('Error al exportar a Excel:', error);
        this.loading = false;
        // Aquí puedes agregar un manejo de errores más robusto, como mostrar un mensaje al usuario
      }
    },

    async getAllRecords() {
      const totalRecords = this.totalRegistros;
      const params = this.getParams();
      params['$limit'] = totalRecords;
      params['$skip'] = 0;

      try {
        const response = await this.findGestiones({ query: params });
        console.log('todas las gestiones: ', response);
        return response.data;
      } catch (error) {
        console.error('Error al obtener todos los registros:', error);
        throw error;
      }
    },
    fnGetDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '';
    },
    fnGetDateUTC(date) {
      return date ? moment(date).utc().format('DD-MM-YYYY') : '';
    },
    fnGetUTCDate(date) {
      return date ? moment(date).utc().format('DD-MM-YYYY') : '';
    },
    fnGetDateTime(date) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss a') : '';
    },
    getYearMonth(dateString) {
      // Parse the date string to a Date object
      const date = new Date(dateString);

      // Extract the year and month
      const year = date.getFullYear();
      // Months are zero-indexed, so add 1 and pad with zero if necessary
      const month = String(date.getMonth() + 1).padStart(2, '0');

      // Concatenate year and month
      return `${year}${month}`;
    },
    //
    ...mapActions('GestionesEventosComentarios', {
      findGestiones: 'find',
      createGestiones: 'create',
      patchGestiones: 'patch',
    }),
    ...mapActions([
      'setModalFechas',
      'setDialogVarSelectedRangueFecha',
      'saveDateRange',
    ]),
    /**paginacion */
    handlePageChange(value) {
      this.page = value;
      this.main();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.main();
    },
    /**paginacion fin */
    getParams() {
      const params = {};
      params['$limit'] = this.pageSize;
      params['$skip'] = (this.page - 1) * this.pageSize;

      // params['$or'] = [
      //   { flag_precalificacion_en_revision: 1 },
      //   { flag_precalificacion_con_pendientes: 1 },
      //   { flag_precalificacion_con_rectificacion: 1 },
      //   { flag_precalificacion_con_compromiso_de_pago: 1 },
      // ];

      // params['flag_precalificacion_listo_para_aprobacion'] = { $eq: null };
      // params['flag_precalificacion_concluidas'] = { $eq: null };
      // params['flag_precalificacion_cancelada'] = { $eq: null };
      /** */
      /**fechas */
      /** */
      params['createdAt'] = {
        $gte: this.getFirstDay,
        $lte: this.getLastDay,
      };
      /** */
      /**fechas */

      Object.keys(this.filters).forEach((key) => {
        let filterValue = this.filters[key];
        if (!filterValue) return;

        const header = this.headers.find((h) => h.value === key);
        if (!header) return;

        if (header.type === 'string' && !header.multi) {
          // Trim leading and trailing spaces
          filterValue = filterValue.trim();
          params[key] = { $like: `%${filterValue}%` };
        } else if (header.type === 'integer') {
          params[key] = filterValue;
        } else if (header.type === 'boolean') {
          params[key] = filterValue;
          params[key] = filterValue === 0 ? { $eq: null } : Boolean(filterValue);
        } else if (header.type === 'date' || header.type === 'datetime') {
          filterValue = filterValue.trim();

          let split_filterValue = filterValue.split('-');
          var firstDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0], 0, 0, 0);
          var lastDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0], 23, 59, 59);


          params[key] = {
            $gte: firstDay,
            $lte: lastDay,
          };

        }
        else if (header.type === 'dateUTC') {
          filterValue = filterValue.trim();

          let split_filterValue = filterValue.split('-');

          let firstDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0] - 2, 23, 59, 59);
          let lastDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0] - 1, 23, 59, 59);


          params[key] = {
            $gte: firstDay,
            $lte: lastDay,
          };

        }
        // Add more conditions for other types like 'betweendate'
      });
      /** */
      if (
        this.options.sortBy &&
        this.options.sortBy.length === 1 &&
        this.options.sortDesc.length === 1
      ) {
        let sorting = {};
        let flag = this.options.sortDesc[0] ? -1 : 1;
        sorting[this.options.sortBy[0].toString()] = flag;
        params['$sort'] = sorting;
      } else {
        params['$sort'] = { id: -1 };
      }

      return params;
    },
    /** */
    main() {
      console.log('parametros: ', this.getParams())
      this.findGestiones({ query: this.getParams() }).then((r) => {
        this.items = r.data;
        this.totalRegistros = r.total;
        this.totalPages = Math.ceil(
          parseInt(r.total) / parseInt(this.pageSize)
        );
      });
    },
    /** */
    applyFilters() {
      this.page = 1;
      this.main();
      // Function to apply filters and fetch data
      // eslint-disable-next-line no-unused-vars
      const params = this.getParams();
      // Use the params to fetch data from Feathers service
    },
  },
  mounted() {
    this.main();
  },
};
</script>
